<template>
  <ValidationObserver v-slot="{ handleSubmit, reset }">
    <b-form
      ref="addressForm"
      @submit.prevent="handleSubmit(onSubmit)"
      @reset.prevent="reset"
    >
      <b-form-group class="mb-4">
        <label>Region <span class="optional">(Optional)</span></label>
        <validation-provider
          name="business province"
          rules=""
          v-slot="validationContext"
        >
          <b-form-select
            :state="getValidationState(validationContext)"
            v-model="address.regionId"
            placeholder="Select Province"
            class="form-select"
            :options="regionOptions"
            @change="getProvinces"
          >
          </b-form-select>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>

      <b-form-group class="mb-4">
        <label>Province <span class="optional">(Optional)</span></label>
        <validation-provider
          name="business province"
          rules=""
          v-slot="validationContext"
        >
          <b-form-select
            :state="getValidationState(validationContext)"
            :disabled="provinceOptions.length == 1"
            v-model="address.provinceId"
            placeholder="Select Province"
            class="form-select"
            :options="provinceOptions"
            @change="getCities"
          >
          </b-form-select>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>

      <b-form-group class="mb-4">
        <label>City <span class="optional">(Optional)</span></label>
        <validation-provider
          name="business city"
          rules=""
          v-slot="validationContext"
        >
          <b-form-select
            :state="getValidationState(validationContext)"
            :disabled="cityOptions.length == 1"
            v-model="address.cityId"
            placeholder="Select City"
            class="form-select"
            :options="cityOptions"
            @change="getBarangays"
          >
          </b-form-select>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>

      <b-form-group class="mb-4">
        <label>Barangay <span class="optional">(Optional)</span></label>
        <validation-provider
          name="business barangay"
          rules=""
          v-slot="validationContext"
        >
          <b-form-select
            :state="getValidationState(validationContext)"
            :disabled="barangayOptions.length == 1"
            v-model="address.barangayId"
            placeholder="Select Barangay"
            class="form-select"
            :options="barangayOptions"
          >
          </b-form-select>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>

      <b-form-group class="mb-4">
        <label
          >Building / Street Name / District
          <span class="optional">(Optional)</span></label
        >
        <validation-provider
          name="business street address"
          rules=""
          v-slot="validationContext"
        >
          <b-form-input
            :state="getValidationState(validationContext)"
            placeholder="Enter Street Address"
            v-model="address.street"
            trim
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>

      <div class="d-flex">
        <div class="w-50 d-flex">
          <div class="align-self-center cursor-pointer" @click="onBack">
            <feather type="chevron-left" class="icon-md text-primary"></feather>
            Back to Business Details
          </div>
        </div>
        <div class="w-50">
          <b-button
            class="w-100"
            type="submit"
            variant="primary"
            :disabled="isRegisterLoading"
          >
            <span
              v-if="isRegisterLoading"
              class="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Next
          </b-button>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import {
  authComputed,
  authMethods,
  addressComputed,
  addressMethods,
} from "@/state/helpers";

export default {
  props: ["value", "isRegisterLoading"],
  data() {
    return {
      address: this.value,
    };
  },
  watch: {
    address: {
      handler(val) {
        val.province = this.province;
        val.city = this.city;
        val.barangay = this.barangay;
        val.region = this.region;
        this.$emit("update", val);
      },
      deep: true,
    },
  },
  computed: {
    ...authComputed,
    ...addressComputed,
    region() {
      var name = "";
      for (var i = 0; i < this.regions.length; i++) {
        if (this.regions[i].regionId == this.address.regionId) {
          name = this.regions[i].regionName;
        }
      }
      return name;
    },
    province() {
      var name = "";
      for (var i = 0; i < this.provinces.length; i++) {
        if (this.provinces[i].provinceId == this.address.provinceId) {
          name = this.provinces[i].provinceName;
        }
      }
      return name;
    },
    city() {
      var name = "";
      for (var i = 0; i < this.cities.length; i++) {
        if (this.cities[i].cityId == this.address.cityId) {
          name = this.cities[i].cityName;
        }
      }
      return name;
    },
    barangay() {
      var name = "";
      for (var i = 0; i < this.barangays.length; i++) {
        if (this.barangays[i].brgyId == this.address.barangayId) {
          name = this.barangays[i].brgyName;
        }
      }
      return name;
    },
    regionOptions() {
      return [
        { text: "Select Region", value: null },
        ...this.regions.map((r) =>
          Object.assign({}, { text: r.regionName, value: r.regionId })
        ),
      ];
    },
    provinceOptions() {
      return [
        { text: "Select Province", value: null },
        ...this.provinces.map((p) =>
          Object.assign({}, { text: p.provinceName, value: p.provinceId })
        ),
      ];
    },
    cityOptions() {
      return [
        { text: "Select City", value: null },
        ...this.cities.map((c) =>
          Object.assign({}, { text: c.cityName, value: c.cityId })
        ),
      ];
    },
    barangayOptions() {
      return [
        { text: "Select Barangay", value: null },
        ...this.barangays.map((b) =>
          Object.assign({}, { text: b.brgyName, value: b.brgyId })
        ),
      ];
    },
  },
  methods: {
    ...authMethods,
    ...addressMethods,
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getCities() {
      this.fetchCities({ 
        provinceId: this.address.provinceId, 
        storeCount: 0
      });
    },
    getBarangays() {
      this.fetchBarangays({
        cityId: this.address.cityId,
        storeCount: 0
      });
    },
    getProvinces() {
      this.fetchProvinces({
        regionId: this.address.regionId,
        storeCount: 0  
      });
    },
    onSubmit: function () {
      this.$emit("submit");
    },
    onBack: function () {
      this.$emit("back");
    },
  },
  mounted() {
    this.fetchRegions({ storeCount: 0 });
  },
};
</script>

<style>
</style>